module.exports = __webpack_public_path__ + "static/item3_bg.80fc13f9.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/item3_bg.png
// module id = 1049
// module chunks = 2